import { render, staticRenderFns } from "./contactSummaryWidget.vue?vue&type=template&id=0cc6be33&"
import script from "./contactSummaryWidget.vue?vue&type=script&lang=js&"
export * from "./contactSummaryWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports